import { Badge } from 'antd'
import { observer } from 'mobx-react-lite'

import { classNames } from '@/Ship/Helpers/classNames'
import { counterManager } from '@/Ship/Stores/CounterManager'

import { MENU_BADGE_OVERFLOW } from './MenuBadgeLabel'

import type { ReactNode } from 'react'

import styles from './MenuBadge.module.css'

interface MenuBadgeIconProps {
    /** Код лічильника з `GET /services/counters`: `activity`. */
    counter: string
    /** Іконка пункту. */
    children: ReactNode
    /** Клас від antd (`ant-menu-item-icon`) — меню клонує іконку й додає його. */
    className?: string
}

/**
 * Іконка пункту меню з лічильником для згорнутого сайдера (`SPEC-014` §3.2):
 * там підпису не видно, тож число висить на іконці. У розгорнутому сайдері
 * воно приховане стилем — бейдж уже стоїть біля підпису (`MenuBadgeLabel`).
 */
export const MenuBadgeIcon = observer(({ counter, children, className }: MenuBadgeIconProps) => {
    const count = counterManager.value(counter)

    return (
        <span className={classNames(className, styles['icon'])}>
            <Badge count={count} overflowCount={MENU_BADGE_OVERFLOW} size="small" offset={[4, -2]}>
                {children}
            </Badge>
        </span>
    )
})

MenuBadgeIcon.displayName = 'MenuBadgeIcon'
